<div fxLayout="column" fxFlex="grow" style="overflow-y: auto;">
    <div fxLayout="row" fxFlex fxLayoutAlign="start center center" class="modal-header">
        <span fxFlex class="modal-title">{{mode !== 4 ? 'Αποστολή ενημέρωσης' : 'Αποστολή προσωπικού μηνύματος'}}</span>
        <mat-icon (click)="close()" class="modal-close">close</mat-icon>
    </div>

    <div fxLayout="row"
         fxFlex="grow"
         style="margin-top: 20px;"
         fxLayoutAlign="start center center">

        <div fxLayout="column" fxFlex fxLayoutGap="15px">
            <div fxLayout="row" fxFlex *ngIf="+mode === 0 || +mode === 1">
                <div fxFlex="30">Παραλήπτες</div>
                <div fxFlex="70">
                    <mat-form-field>
                        <mat-select [disabled]="isLoading" [(ngModel)]="selectedRecipientGroup" (selectionChange)="groupChange()" placeholder="Επιλέξτε ομάδα παραληπτών" >
                            <mat-option *ngFor="let group of recipientsGroup" [value]="group">  {{group.label}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div fxLayout="row" fxFlex>
                <div fxFlex="30" fxLayoutAlign="start center center">
                    <span style="vertical-align: center;">Χρήστες</span>
                </div>
                <div fxFlex="70">
                    <div fxLayout="row" fxFlex >
                        <div fxLayout="column" fxFlex>
                            <div fxLayout="row" >
                                <mat-form-field fxFlex appearance="outline">
                                    <mat-chip-list #chipList [disabled]="mode === 4">
                                        <mat-chip
                                                matTooltip="Email: {{email.email}} - Τηλέφωνο: {{email.phone}}"
                                                style="height: auto; background-color: var(--primary); color: white;"
                                                *ngFor="let email of emails"
                                                [selectable]="selectable"
                                                [removable]="removable"
                                                (removed)="removeEmail(email)">

                                            <div fxLayout="column">
                                                <div fxLayout="row">
                                                    {{email.displayName}}
                                                    <!--                                                    {{email.label}}-->
                                                </div>
                                            </div>
                                            <mat-icon matChipRemove style="color: white" *ngIf="removable">cancel
                                            </mat-icon>
                                        </mat-chip>

                                        <input matInput
                                               [disabled]="mode === 4"
                                               #emailInput
                                               placeholder="Αναζήτηση"
                                               aria-label="State"
                                               [matAutocomplete]="auto"
                                               [matChipInputFor]="chipList"
                                               [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                               [matChipInputAddOnBlur]="addOnBlur"
                                               (matChipInputTokenEnd)="addEmail($event)"
                                               [formControl]="emailsCtrl" style="width: 100%;">
                                    </mat-chip-list>

                                    <mat-autocomplete  #auto="matAutocomplete" [displayWith]="displayFn"
                                                      style="width: 100%;"
                                                      (optionSelected)="selected($event)">
                                        <mat-option *ngIf="isLoading" class="is-loading">
                                            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                                        </mat-option>
                                        <ng-container *ngIf="!isLoading">
                                            <mat-option *ngFor="let user of filteredUsers" [value]="user">
                                                <span>{{user.firstName}} {{user.lastName}} &nbsp;<span
                                                        style="font-size: 12px;">(τηλ: {{user.telephone}}
                                                    email: {{user.email[0]}})</span></span>
                                            </mat-option>
                                        </ng-container>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxFlex>
                                <ng-container *ngIf="errorMsg">
                                    {{errorMsg}}
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div fxLayout="row" fxFlex *ngIf="mode !== 4">
                <div fxFlex="30" fxLayoutAlign="start center center">
                    <span>Μέθοδος αποστολής</span>
                </div>
                <div fxFlex="70">
                    <div fxLayout="column" >
                        <div fxLayout="row" fxFlex fxLayoutAlign="start center center" fxLayoutGap="20px">
                            <div>
                                <label>Email</label> &nbsp;
                                <mat-slide-toggle [disabled]="isLoading" (change)="notificationMode=1" [checked]="notificationMode === 1" color="primary"></mat-slide-toggle>
                            </div>

                            <div>
                                <label>SMS</label> &nbsp;
                                <mat-slide-toggle [disabled]="isLoading" (change)="notificationMode=2" [checked]="notificationMode === 2" color="primary"></mat-slide-toggle>
                            </div>

                            <div>
                                <label>Email & SMS</label> &nbsp;
                                <mat-slide-toggle [disabled]="isLoading" (change)="notificationMode=3" [checked]="notificationMode === 3" color="primary"></mat-slide-toggle>
                            </div>

                            <div><label>Προεπιλογή χρήστη</label> &nbsp;
                                <mat-slide-toggle [disabled]="isLoading" (change)="notificationMode=4" [checked]="notificationMode === 4" color="primary">
                                </mat-slide-toggle>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div fxLayout="row" fxFlex>
                <div fxFlex="30" fxLayoutAlign="start center center">
                    <span>Θέμα</span>
                </div>
                <div fxFlex="70">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <label>
                            <input [disabled]="isLoading" matInput [(ngModel)]="subject" placeholder="Θέμα"
                                   style="display:table-cell; width:100%;">
                        </label>
                    </mat-form-field>
                </div>
            </div>
        </div>

    </div>
    <div fxLayout="row" fxFlex>
        <quill-editor [disabled]="isLoading" fxFlex="100" [styles]="editorStyle" [innerHTML]="textContent" [(ngModel)]="htmlContent"></quill-editor>
    </div>
    <div fxLayout="row" fxFlex fxLayoutAlign="end center center" style="margin-top:5px;">
       <span>Μέγεθός απλού μηνύματος{{plainTextLength()}}</span>&nbsp; <span>Μέγεθος email{{htmlContent?.length}}</span>
    </div>

    <div fxLayout="row" fxLayoutAlign="center center center">
        <button *ngIf="mode !== 4" mat-raised-button color="primary" [class.spinner]="loading" [disabled]="loading" (click)="sendMessage()">Αποστολή ενημέρωσης</button>
        <button *ngIf="mode === 4" mat-raised-button color="primary" [class.spinner]="loading" [disabled]="loading" (click)="sendDirectMessage()">Αποστολή μηνύματος</button>
    </div>
</div>
